import edu from "./education/es";
import lib from "./library/es";
import al from "./assets/es";
import vm from "./videoMoments/es";
import iv from "./interview/es";
import lvl from "./level/es";
import pm from "./practice/es";
// Phase 5.3 — Spanish (Español)
const es = {
  footer: { forSchools: "Para centros educativos", tagline: "Tu vida se convierte en tu curso de idiomas.", eu: "Hecho para la UE 🇪🇺 · RGPD primero · Nunca guardamos tus fotos ni tu voz.", product: "Producto", signIn: "Iniciar sesión", getStarted: "Empezar", legal: "Legal", privacy: "Política de privacidad", terms: "Condiciones del servicio" },
  cookie: { title: "Valoramos tu privacidad 🍪", body: "GetFluentLoop usa cookies esenciales para mantener tu sesión iniciada. Nunca vendemos tus datos y nunca guardamos tus fotos ni tus grabaciones de voz originales. Consulta nuestra", link: "Política de privacidad", end: ".", accept: "Aceptar", decline: "Rechazar" },
  cefr: {"A1": "Sé algunas palabras", "A2": "Frases sencillas del día a día", "B1": "Puedo mantener una charla básica", "B2": "Me defiendo con bastante soltura", "C1": "Me siento muy cómodo", "C2": "Casi nativo"},
  landing: { imgAlt: "Estudiante", streakBadge: {"one": "¡{count} día seguido!", "other": "¡{count} días seguidos!"}, heroSub: "Aprende de lo que ves, piensas, dices, lees y vives, mientras GetFluentLoop adapta el idioma a tu vida real. Empieza gratis en segundos.","freeTag": "GRATIS", "featJournal": "Diario de voz", "featToday": "Hoy inteligente", "descLoop": "¿Ves algo? Hazle una foto y aprende la palabra al instante.", "descFriend": "¿Piensas algo? Dilo con naturalidad: habla de tu vida en el idioma que estás aprendiendo.", "descLens": "Lee carteles, menús, objetos y escenas a tu alrededor, y aprende de ellos.", "descJournal": "Cuenta tu día con tus propias palabras, hablando o escribiendo. Escúchalo con naturalidad en tu nuevo idioma.", "descToday": "Vuelve mañana: tu Cerebro de aprendizaje prepara la siguiente lección breve en torno a lo que te importa.", "mockLearned": "Hoy aprendiste", "mockGloss": "El árbol es muy alto."},
  dash: { freezeSaved: {"one": "🛡️ Un protector de racha salvó tu racha de {count} día", "other": "🛡️ Un protector de racha salvó tu racha de {count} días"},"hey": "Hola, {name} 👋", "heyAnon": "¡Hola! 👋", "learning": "Aprendiendo {lang} · Nivel {level}", "recap": "Resumen semanal", "upgrade": "Pásate a Pro", "todayLoop": "El Loop de hoy", "todayLoopSub": "Tu sesión personalizada de 5 minutos: empieza ya", "classAssignments": "Tareas de clase", "viewAll": "Ver todas →", "continue": "Continuar", "start": "Empezar", "allCaught": "Todo al día. ¡Buen trabajo! 🎉", "momentum": "Tu impulso", "freezeHelp": "Los protectores de racha cuidan tu racha si te saltas un día", "freezes": {"one": "{count} protector", "other": "{count} protectores"}, "streakCalendar": "Ver calendario de racha →", "totalXp": "XP total", "wordsLearned": "palabras aprendidas", "dueForReview": "para repasar →", "captures": "capturas", "conversations": "conversaciones", "accentTrend": "Evolución del acento", "noScores": "Aún no hay puntuaciones. Prueba", "noScoresEnd": ".", "recent": "Actividad reciente", "nothingYet": "Nada todavía. ¡Empieza a capturar!", "jumpBack": "Retoma donde lo dejaste"},
  nudge: {"streakTitle": {"one": "¡Mantén viva tu racha de {count} día!", "other": "¡Mantén viva tu racha de {count} días!"}, "streakSub": "Haz el Loop de hoy para no perderla.", "startLoop": "Empezar Loop", "dueTitle": {"one": "{count} palabra lista para repasar", "other": "{count} palabras listas para repasar"}, "dueSub": "Un Loop de 2 minutos las mantiene en tu memoria a largo plazo.", "reviewNow": "Repasar ahora"},
  tour: {"t1": "¡Bienvenido a GetFluentLoop! 🎉", "b1": "Una app que convierte tu vida diaria en tu curso de idiomas: cada función alimenta un mismo banco de vocabulario.", "t2": "Apunta con tu cámara", "b2": "LanguageLoop convierte cualquier cosa a tu alrededor en una palabra: haz una foto y obtén la palabra, una frase y la pronunciación.", "t3": "Practica de verdad", "b3": "Chatea con tu Roommate de IA, evalúa tu acento, debate un tema y ponte a prueba con tus propias palabras.", "t4": "El Loop de hoy", "b4": "¿No sabes por dónde empezar? Toca el Loop de hoy para una sesión personalizada de 5 minutos, cada día.", "t5": "Crea una racha", "b5": "Practica a diario para hacer crecer tu racha, y guarda protectores de racha para que un día ajetreado no la rompa.", "back": "Atrás", "next": "Siguiente", "start": "Empezar a aprender", "skip": "Saltar recorrido"},
  vocabSrc: {"manual": "Añadida por ti", "mission": "Misión", "word_explorer": "Explorador de palabras", "object_lens": "FluentLens · Objeto", "scene_lens": "FluentLens · Escena", "text_lens": "FluentLens · Texto", "fluent_friend_live": "Amigo en vivo"},
  common: {
    save: "Guardar", cancel: "Cancelar", add: "Añadir", addSelected: "Añadir selección",
    addAll: "Añadir palabras útiles", delete: "Eliminar", edit: "Editar", retake: "Repetir foto",
    scanAgain: "Escanear de nuevo", continue: "Continuar", back: "Atrás", next: "Siguiente",
    close: "Cerrar", loading: "Cargando…", search: "Buscar", logout: "Cerrar sesión",
    settings: "Ajustes", listen: "Escuchar", stop: "Detener", added: "Añadido",
  },
  nav: {
    educationadmin: "Admin. Educación",
    more: "Más",
    dashboard: "Panel", today: "Hoy", languageloop: "LanguageLoop",
    fluentlens: "FluentLens", roommate: "Roommate", accentcoach: "AccentCoach",
    debategym: "DebateGym", quizforge: "QuizForge", story: "Historia",
    "vocab bank": "Vocabulario", "discovery lab": "Discovery Lab", assignments: "Tareas", myclasses: "Mis clases", teacher: "Docente", journal: "Diario", friend: "Amigo",
  },
  auth: { welcomeBack: "¡Hola de nuevo!", welcomeNew: "¡Bienvenido a GetFluentLoop! 🎉",
    signInTitle: "Bienvenido de nuevo", signUpTitle: "Crea tu cuenta",
    signInSub: "Inicia sesión para seguir aprendiendo.", signUpSub: "Empieza a aprender en menos de un minuto.",
    continueWithGoogle: "Continuar con Google", or: "O", yourName: "Tu nombre",
    email: "Correo", password: "Contraseña", iSpeak: "Hablo", imLearning: "Estoy aprendiendo",
    myLevel: "Mi nivel", createAccount: "Crear cuenta", signIn: "Iniciar sesión",
    acceptTerms: "Acepto los Términos y la Política de Privacidad.",
    haveAccount: "¿Ya tienes cuenta?", noAccount: "¿Eres nuevo?",
  },
  onboarding: {
    allSet: "¡Todo listo! 🎉",
    welcome: "Bienvenido a GetFluentLoop", title: "Vamos a configurarte",
    subtitle: "Cuéntanos qué estás aprendiendo.", iSpeak: "Hablo",
    imLearning: "Estoy aprendiendo", level: "Nivel", finish: "Empezar a aprender",
    allSet: "¡Todo listo! 🎉",
  },
  settings: {
    title: "Ajustes", interfaceLanguage: "Idioma de la interfaz",
    interfaceLanguageHelp: "El idioma de los menús, botones y mensajes. Esto no cambia lo que estás aprendiendo.",
    learning: "Aprendiendo", native: "Nativo", level: "Nivel",
    learningProfiles: "Perfiles de aprendizaje",
    learningProfilesHelp: "Ten varios idiomas en una sola cuenta. Cambiar de perfil solo afecta a tu contexto de aprendizaje: tu cuenta, rol y centros no cambian.",
    addProfile: "Añadir perfil de idioma", switch: "Cambiar", active: "Activo",
    createAndSwitch: "Crear y cambiar", nameOptional: "Nombre (opcional)",
    pickDifferent: "Elige dos idiomas distintos para hablar y aprender.",
    profileSwitched: "Perfil de aprendizaje cambiado",
  },
  lens: {
    home: "FluentLens", tagline: "Apunta con la cámara al mundo y aprende el idioma que te rodea.",
    textLens: "Lente de texto", objectLens: "Lente de objetos", studyLens: "Lente de estudio",
    sceneLens: "Lente de escena", takePhoto: "Hacer foto", uploadImage: "Subir imagen",
    translate: "Traducir", explain: "Explicar", quizMe: "Ponme a prueba", describe: "Describir",
    identifyCount: "Identificar y contar", learnVocab: "Aprender vocabulario",
    saveScan: "Guardar en archivo", archive: "Archivo", usefulVocab: "Vocabulario útil",
    naturalTranslation: "Traducción natural", gist: "Idea general", check: "Comprobar",
    addWord: "Añadir palabra", addRelated: "Añadir palabras relacionadas", wordsAround: "Palabras relacionadas",
    whereThings: "Dónde están las cosas", suggestedAnswer: "Respuesta sugerida",
  },
  mission: {
    speak: "Hablar", type: "Escribir", startRecording: "Toca para hablar", stop: "Detener",
    retry: "Reintentar", usefulPhrases: "Frases útiles", wordsToRemember: "Palabras para recordar",
    completeMission: "Completar misión", nextStep: "Siguiente paso", recap: "resumen de aprendizaje",
    showRecap: "Mostrar", hideRecap: "Ocultar", typeFirst: "Escribe tu primera respuesta para empezar.",
    speakFirst: "Toca el micrófono y di tu primera frase para empezar.",
    typeReply: "Escribe tu respuesta…",
  },
  home: {
    badge: "🇪🇺 Hecho en la UE · Privacidad primero · Global por diseño",
    heroPre: "Tu vida se convierte", heroPost: "en tu curso de", heroWord: "idiomas",
    getStarted: "Empezar", signIn: "Iniciar sesión", dashboard: "Panel",
    tryFree: "Prueba LanguageLoop gratis", startLearning: "Empezar a aprender",
    privacy: "Ninguna foto o grabación se almacena jamás.",
    bundlesTitle: "Todo alimenta un solo ciclo de aprendizaje.",
    bundlesSub: "Descubre una palabra en cualquier lugar, explórala y recuérdala. Cada función comparte un banco de vocabulario, una memoria de lo que sabes y un plan diario tranquilo.",
    priceSub: "Todo incluido. Cancela cuando quieras.", startNow: "Empezar ahora",
  },
  pilot: {
    daysRemaining: { one: "Queda {count} día", other: "Quedan {count} días" },
  },
  today: { dueSoon: "Vence pronto", overdue: "Atrasada", continueMission: "Continúa tu misión de clase", yourMission: "Tu misión de clase", minutes: {"one": "~{count} min", "other": "~{count} min"}, stepsProgress: "{done}/{total} pasos", wordProgress: "Palabra {n} / {total}", unlockPro: "Desbloquear con Pro", skipForNow: "Saltar por ahora", weHeard: "Oímos:", skip: "Saltar", snapHint: "Haz una foto a cualquier objeto a tu alrededor para añadir una palabra nueva a tu banco.", doLater: "Lo haré más tarde", bonusXp: {"one": "+{count} XP de bonificación", "other": "+{count} XP de bonificación"}, micUnavailable: "Micrófono no disponible.", scoringFailed: "No se pudo puntuar.", paywallReason: "La puntuación de pronunciación forma parte de GetFluentLoop Pro.",
    title: "Tu sesión de hoy", subtitle: "Tu sesión personalizada de 5 minutos.",
    dayStreak: { one: "día seguido", other: "días seguidos" }, streakText: {"one": "{count} día seguido", "other": "{count} días seguidos"}, startLoop: "Empezar la sesión de hoy", reveal: "Mostrar respuesta",
    gotIt: "Lo sabía", missedIt: "Fallé", sayItOut: "Dilo en voz alta", hearIt: "Escuchar",
    skip: "Omitir", continue: "Continuar", loopComplete: "¡Sesión completada!",
    loopCompleteToday: "¡Sesión de hoy completada!", comeBack: "Vuelve mañana.",
    backToDashboard: "Volver al panel", word: "Palabra", reviewWords: "Repasar palabras",
    saySentence: "Di una frase", captureNew: "Captura algo nuevo",
    openCamera: "Abrir cámara", learnNewWord: "Aprende una palabra nueva", practiceAgain: "Practicar de nuevo",
  },
  wordExplorer: {
    script: "Alfabeto",
    scriptSaved: "Preferencia de alfabeto guardada",
    pos: {
      noun: "sustantivo",
      verb: "verbo",
      adjective: "adjetivo",
      adverb: "adverbio",
      pronoun: "pronombre",
      preposition: "preposición",
      conjunction: "conjunción",
      phrase: "expresión",
      other: "otro",
      related: "relacionada",
    },
    labels: {
      present: "Presente",
      past_compose: "Pasado (passé composé)",
      past_preterite: "Pasado (pretérito)",
      imperfect: "Imperfecto",
      future: "Futuro",
      conditional: "Condicional",
      subjunctive: "Subjuntivo",
      singular: "Singular",
      plural: "Plural",
      nominative: "Nominativo",
      genitive: "Genitivo",
      dative: "Dativo",
      accusative: "Acusativo",
      instrumental: "Instrumental",
      prepositional: "Preposicional",
      present_imperfective: "Presente (imperfectivo)",
      future_perfective: "Futuro (perfectivo)",
      past: "Pasado",
      imperative: "Imperativo",
      forms: "Formas",
      masculine: "masculino",
      feminine: "femenino",
      neuter: "neutro",
      short_m: "corta m.",
      short_f: "corta f.",
      short_forms: "Formas cortas",
    },
    explore: "Explorar",
    exploreWord: "Explorar «{word}»",
    title: "Explorador de palabras",
    howChanges: "Cómo cambia esta palabra",
    seeMoreForms: "Ver más formas",
    family: "Familia de palabras",
    usage: "Cómo se usa de verdad",
    traps: "Errores comunes",
    examples: "Ejemplos naturales",
    save: "Guardar en vocabulario",
    saved: "Guardada en vocabulario",
    aiAssisted: "Formas asistidas por IA",
    aiAssistedHelp: "Estas formas se generaron y verificaron automáticamente.",
    unlock: "Desbloquea el Explorador de palabras con Pro",
    unlockSub: "Todas las formas útiles, la familia de palabras, el uso real, errores comunes y más ejemplos.",
    unlockCta: "Desbloquear con Pro",
    more: "Más usos y ejemplos",
    loading: "Explorando…",
    failed: "No pudimos explorar esa palabra. Revisa la ortografía.",
    back: "Vocabulario",
    listen: "Escuchar",
    alsoMeans: "También",
  },
  vocab: { markKnown: "Marcar como conocida",
    title: "Vocabulario", subtitle: "Cada palabra que has aprendido.", searchWords: "Buscar palabras…",
    all: "Todas", known: "Conocidas", learning: "Aprendiendo", removed: "Eliminada", markKnown: "Marcar como conocida",
    empty: "Aún no hay palabras. ¡Captura algunas con FluentLens!",
  },
  journal: {
    title: "Diario de voz", tagline: "Habla tu vida. Aprende a decirla.",
    speak: "Hablar", type: "Escribir", recording: "Grabando… toca para parar",
    typePlaceholder: "Escribe en tu idioma…",
    intro: "Habla de tu día, tus planes o cómo te sientes, en tu propio idioma.",
    review: "Revisa tu idea", reviewHelp: "Revisa la transcripción y corrige antes de traducir.",
    retry: "Grabar de nuevo", seeHowToSay: "Ver cómo se dice",
    whatYouSaid: "Lo que dijiste", howToSay: "Cómo decirlo en {lang}",
    practice: "Practica decirlo", practicing: "Grabando tu práctica…", playYours: "Escucha tu intento",
    usefulWords: "Palabras útiles", usefulPhrases: "Frases útiles", grammar: "Gramática a tener en cuenta",
    actions: "Acciones posibles", saveEntry: "Guardar en el diario", saved: "Guardado en tu diario",
    archive: "Tu diario", empty: "Aún no hay entradas: habla o escribe tu primera idea.",
    newEntry: "Nueva entrada", rename: "Renombrar", deleted: "Entrada eliminada",
    micDenied: "Micrófono no disponible: escribe.", analyzing: "Buscando la forma natural de decirlo…",
    transcribing: "Escuchando…",
  },
  friend: {
    live: {
      "premium": "Fluent Friend es una función premium.",
      "voiceUnavailable": "La voz no está disponible ahora mismo.",
      "genericError": "Algo salió mal. Inténtalo de nuevo.",
      "start": "Iniciar conversación en vivo",
      "tag": "En vivo",
      "intro": "Habla directamente en el idioma que estás aprendiendo. Fluent Friend mantendrá la conversación. Si te atascas, usa «Ayúdame a decirlo».",
      "ideas": "Ideas para empezar",
      "speak": "Hablar",
      "stop": "Parar",
      "type": "Escribe en el idioma que estás aprendiendo…",
      "help": "Ayúdame a decirlo",
      "helpTitle": "Dilo en tu idioma",
      "helpPlaceholder": "Di o escribe lo que quieres decir…",
      "helpGo": "Muéstrame cómo decirlo",
      "helped": "Querías decir",
      "end": "Terminar conversación",
      "voice": "Voz del amigo",
      "listening": "Escuchando…",
      "understanding": "Entendiendo…",
      "thinking": "Pensando…",
      "retry": "Reintentar",
      "replyFailed": "Fluent Friend no pudo responder ahora; tu mensaje está a salvo.",
      "sttFailed": "No te entendimos. Inténtalo de nuevo o escribe.",
      "meaning": "Ver significado",
      "saved": "Conversación guardada.",
      "recapTitle": "Lo que practicaste",
      "keep": "Expresiones que vale la pena guardar",
      "addAll": "Añadir todas las útiles",
      "moreNatural": "Una cosa para decir de forma más natural",
      "handledWell": "Algo que hiciste bien",
      "practiceAgain": "Para practicar de nuevo",
      "starter": {
        "day": "Cuéntame tu día",
        "plans": "¿Qué planes tienes?",
        "happened": "¿Pasó algo interesante?",
        "work": "¿Hablamos de trabajo o estudios?",
        "forward": "¿Qué esperas con ilusión?"
      }
    },
    title: "Fluent Friend", tagline: "Habla de tu vida. Aprende con la conversación.",
    intro: "Habla con naturalidad en tu idioma. Fluent Friend te ayuda a decirlo en {lang} y sigue la conversación ahí.",
    introText: "Escribe con naturalidad en tu idioma. Di lo que de verdad quieres expresar: Fluent Friend te ayuda a decirlo en {lang} y sigue la conversación ahí.",
    speak: "Hablar", type: "Escribir", send: "Enviar", placeholder: "Di algo en tu idioma…",
    reviewHint: "Revisa lo que dijiste y envíalo.", youCouldSay: "Podrías decir",
    showMeaning: "Ver significado", hideMeaning: "Ocultar significado",
    recap: "Lo que practicaste", newChat: "Nueva conversación", conversations: "Conversaciones",
    empty: "Aún no hay conversaciones: empieza hablando de tu día.",
    startersTitle: "¿No sabes por dónde empezar?",
    starters: ["Cuéntame sobre tu día", "¿Algo en tu mente?", "¿Qué estás planeando?", "¿Hablamos del trabajo?", "Cuéntame algo bueno que pasó", "¿Qué esperas con ganas?"],
    words: "Palabras útiles", phrases: "Frases útiles", expressions: "Expresiones naturales",
    grammar: "Gramática a tener en cuenta", practiceAgain: "Vale la pena repasar",
    thinking: "Fluent Friend está respondiendo…", recording: "Grabando… toca para parar",
    micDenied: "Micrófono no disponible: escribe.",
  },
  teacher: { dashboard: "Panel del docente", myClasses: "Mis clases" },
  education: {
    title: "FluentLoop para la educación",
    pilotLine: "Programa piloto escolar de 90 días: gratis para centros verificados.",
    apply: "Solicitar el piloto de 90 días", submitting: "Enviando…",
  },
  assignments: {
    title: "Mis tareas", subtitle: "Misiones que tu docente te ha asignado.",
    empty: "No hay tareas por ahora 🎉", emptySub: "Cuando tu docente asigne una misión, aparecerá aquí.",
    doTodayLoop: "Hacer la sesión de hoy", toDo: "Por hacer", inProgress: "En curso", completed: "Completadas",
    start: "Empezar", continue: "Continuar", done: "Hecho", late: "(tarde)",
    overdue: "Vencida", dueToday: "Vence hoy", dueSoon: "Vence pronto", scheduled: "Programada",
  },
  label: {
    gist: "Idea general", vocabulary: "Vocabulario", usefulPhrases: "Frases útiles", grammar: "Gramática",
    verbs: "Verbos", adjectives: "Adjetivos", idioms: "Modismos y colocaciones", relatedWords: "Palabras relacionadas",
    example: "Ejemplo", naturalTranslation: "Traducción natural", whereThings: "Dónde están las cosas",
    reanalyze: "Reanalizar", save: "Guardar", plural: "plural",
  },
  missionRun: {
    breadcrumb: "Tareas", notAvailable: "Esta misión no está disponible para ti.",
    backToAssignments: "Volver a tareas", complete: "¡Misión completada!",
    completeDesc: "Has terminado {title}.",
    myAssignments: "Mis tareas", dashboard: "Panel", yourClass: "Tu clase",
    stepOf: "Paso {current} de {total}", optional: "opcional",
    back: "Atrás", nextStep: "Siguiente paso", continueBonus: "Continuar al extra",
    completeMission: "Completar misión", finishEarly: "He terminado — completar la misión",
    keepWords: "¿Quieres guardar estas palabras para practicar por tu cuenta?", saveToBank: "Guardar en mi banco de vocabulario", notNow: "Ahora no", savedToBank: "Guardado en tu banco de vocabulario.", backToClass: "Volver a la clase", cantSave: "Estas palabras no se pueden guardar en tu banco de vocabulario porque el idioma de esta misión no es uno de tus idiomas de aprendizaje.", saveFailed: "No se pudieron guardar las palabras. Inténtalo de nuevo.",
  },
  lensDesc: {
    text: "Traduce pasajes difíciles y entiende el vocabulario y la gramática.",
    object: "Descubre cómo se llama algo y aprende el idioma a su alrededor.",
    scene: "Observa toda la escena: descríbela, cuenta cosas y aprende el idioma que la rodea.",
    study: "Convierte la lectura del mundo real en práctica de comprensión.",
    archiveSub: "Reabre escaneos anteriores, repasa vocabulario y repite sesiones de estudio.",
    hintText: "Apunta a un libro, cartel, menú o carta", hintObject: "Apunta a un objeto, planta o animal",
    hintScene: "Apunta a una comida, mesa, habitación o paisaje", captureHelp: "Haz una foto o sube una imagen.",
    subText: "Escanea un texto para traducirlo, explicarlo o estudiarlo.",
    subObject: "Apunta a algo para aprender su nombre y el idioma a su alrededor.",
    subScene: "Observa toda la escena. Aprende el idioma que la rodea.",
    subStudy: "Escanea un texto y practica su comprensión.",
    captureSub: "Haz o sube una foto de cualquier objeto para aprender su palabra.",
  },
  todayHelp: {
    refresh: "Refresca lo que se olvida", score: "Evalúa tu pronunciación",
    snap: "Fotografía un objeto", proFeature: "Función Pro", proScoring: "La evaluación de pronunciación es una función Pro",
  },
  capture: {
    title: "¿Qué hay a tu alrededor?", reading: "Leyendo el mundo…",
    pointHint: "Apunta a una taza, un árbol, un perro…", anything: "Cualquier cosa sirve.",
    learnMe: "Apréndela", savedToBank: "Guardada en tu banco", shareCard: "Tarjeta para compartir",
    building: "Creando…", capReached: "Has alcanzado tus capturas diarias gratuitas.",
    keepStreak: "¡Mantén tu racha!", signUpFree: "Regístrate gratis", close: "Cerrar",
    couldNotRead: "No se pudo leer esa imagen. Prueba con otra.",
  },
  review: {
    title: "Repaso", tagline: "Recuerda lo que importa.",
    progress: "{n} de {total}",
    dueCount: { one: "1 palabra lista para repasar.", other: "{count} palabras listas para repasar." },
    recentCount: { one: "Practica 1 palabra reciente.", other: "Practica {count} palabras recientes." },
    allDue: "Todas las pendientes", all: "Todas", start: { one: "Empezar · 1 tarjeta", other: "Empezar · {count} tarjetas" },
    caughtUp: "Lo tienes al día.", nothingDue: "No hay nada que repasar ahora mismo.", practiceRecent: "Practicar palabras recientes",
    reveal: "Mostrar", again: "Otra vez", gotIt: "Lo sé", listen: "Escuchar",
    type: { recognition: "¿Qué significa?", recall: "¿Cómo se dice?", context: "¿Qué palabra encaja?", listening: "Escucha: ¿qué es?", typed: "Escríbelo de memoria" },
    typed: { label: "Escribe tu respuesta", placeholder: "Escríbelo en {lang}", check: "Comprobar", correct: "Correcto", notQuite: "Casi", yourAnswer: "Tu respuesta", answer: "Respuesta", showAnswer: "Ver respuesta", suggestAgain: "Vale la pena repasarlo: «Otra vez» lo trae antes.", checkFailed: "No se pudo comprobar. Inténtalo de nuevo." },
    complete: "Repaso completado", reviewed: "Repasadas", remembered: "Recordadas", anotherLook: "Para volver a ver",
    nextIn: { one: "Próximo repaso en 1 día.", other: "Próximo repaso en {count} días." },
    done: "Hecho", backToday: "Volver a Hoy", todayLink: { one: "Recuerda · 1 palabra pendiente", other: "Recuerda · {count} palabras pendientes" },
    voiceUnavailable: "La voz no está disponible ahora mismo.", saveFailed: "No se pudo guardar. Inténtalo de nuevo.",
  },
  lc: {
    "title": "Tus 5 minutos",
    "subtitle": "Hecho a partir de lo que estás aprendiendo ahora",
    "cold": "Tu ruta diaria será más personal a medida que FluentLoop aprenda lo que te importa.",
    "forYou": "Para ti hoy",
    "assigned": "Asignado",
    "reason": {
      "due": "Vuelve en el momento justo",
      "weak": "Vale la pena recordarlo",
      "activation": "Ya lo has visto, pero aún no lo has usado",
      "relevant": "Guardado recientemente",
      "recently_saved": "Guardado recientemente",
      "stretch": "Da un paso más",
      "function_gap": "Una habilidad útil para practicar",
      "skill": "Una habilidad útil para practicar"
    },
    "kind": {
      "recall": "Recuerda",
      "retrieve": "Recuerda",
      "use_it": "Úsalo",
      "situation": "Situación"
    },
    "howSay": "¿Cómo se dice esto?",
    "write": "Escribe tu respuesta…",
    "check": "Comprobar",
    "skip": "Saltar",
    "notUseful": "No me resulta útil",
    "next": "Siguiente",
    "natural": "Natural",
    "tip": "Consejo",
    "alreadyNatural": "Tu frase ya suena natural.",
    "example": "Ejemplo",
    "saved": "Guardado",
    "useItTpl": "Usa «{word}» en una frase.",
    "useItTopicTpl": "Usa «{word}» en una frase sobre {topic}.",
    "situationTpl": "{function}: escribe 1–2 frases sobre {topic}.",
    "doneTitle": "Por hoy es suficiente.",
    "recalled": "{count} recordadas",
    "used": "{count} usadas",
    "situations": "{count} situación practicada",
    "keepGoing": "Seguir",
    "reviewAll": "Repasar todas las palabras pendientes ({count})",
    "sayAloud": "Di una frase en voz alta",
    "snapWord": "Fotografía una palabra nueva",
    "alsoToday": "También hoy",
    "progress": "{n} de {total}",
    "loading": "Preparando tus 5 minutos…",
    "fn": {
      "asking_question": "Hacer una pregunta",
      "requesting": "Pedir algo",
      "explaining_problem": "Explicar un problema",
      "describing": "Describir algo",
      "narrating_past": "Contar lo que pasó",
      "making_plans": "Hacer planes",
      "apologizing": "Disculparse",
      "agreeing_disagreeing": "Estar de acuerdo o no",
      "expressing_preference": "Decir lo que prefieres",
      "giving_opinion": "Dar tu opinión",
      "clarifying": "Aclarar",
      "small_talk": "Charla informal"
    },
    "topic": {
      "home": "la casa",
      "work": "el trabajo",
      "study": "los estudios",
      "food": "la comida",
      "travel": "los viajes",
      "transport": "moverse por la ciudad",
      "shopping": "las compras",
      "social_life": "amigos y planes",
      "health_everyday": "el bienestar diario",
      "money_everyday": "los gastos diarios",
      "hobbies": "los pasatiempos",
      "culture": "la cultura",
      "nature": "la naturaleza",
      "technology": "la tecnología",
      "everyday_life": "la vida diaria"
    }
  },
  errors: {
    generic: "Algo salió mal. Inténtalo de nuevo.",
    couldNotSave: "No se pudo guardar. Inténtalo de nuevo.",
  },
};
es.pm = pm;
es.lvl = lvl;
es.iv = iv;
es.vm = vm;
es.edu = edu;
es.lib = lib;
es.al = al;
export default es;
